<template>
  <div :class="iconClass" :style="{ width: size + 'px', height: size + 'px', marginRight: '0.3rem' }">
    <slot>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.32351 13.8565L5.49998 14.6506L6.52939 18.3271C6.73528 19.0624 7.49998 19.5624 8.35292 19.3565C9.14704 19.1506 9.58822 18.3271 9.38233 17.533L8.32351 13.8565ZM17 10.1801C18.147 9.70947 18.7941 8.41535 18.4706 7.18006C18.147 5.94476 16.9117 5.18006 15.6765 5.38594L14.5588 1.38594C14.3823 0.797704 13.7941 0.474174 13.2353 0.621233C12.647 0.797704 12.3235 1.38594 12.4706 1.94476L16.0294 14.7389C16.1765 15.2977 16.7647 15.6506 17.3529 15.5036C17.9412 15.3565 18.2647 14.7389 18.0882 14.1801L17 10.1801ZM6.97057 7.20947C6.88233 7.2977 6.85292 7.38594 6.88233 7.50359L8.38233 12.9448C8.41175 13.0624 8.49998 13.1212 8.58822 13.1506L15.4117 14.7977L11.9412 2.26829L6.97057 7.20947ZM7.85292 13.0918C6.2941 7.38594 6.2941 7.68006 6.32351 7.35653L3.67645 8.09182C3.44116 8.15064 3.23528 8.32712 3.11763 8.533C3.02939 8.68006 2.99998 8.82712 2.99998 9.00359C1.88233 9.44476 1.20586 10.7095 1.55881 11.9154C1.85292 13.0036 2.82351 13.7095 3.91175 13.7095C4.05881 13.7095 4.17645 13.7095 4.32351 13.6801C4.47057 13.9742 4.7941 14.1506 5.11763 14.1506C5.20586 14.1506 5.2941 14.1506 5.35292 14.1212L7.99998 13.3859C7.91175 13.2683 7.85292 13.1801 7.85292 13.0918Z"
          fill="currentColor"
        />
      </svg>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'IconLead',
    props: {
      iconClass: {
        type: String,
        default: '',
      },

      size: {
        type: [Number, String],
        default: '',
      },
    },
  };
</script>

<style scoped>
  /* You can add any additional styles here */
</style>
